import { useEffect, useState } from "react";

export enum DimensionUse {
    Nej,
    Ja,
    // Ibland,
    // Krav,
}

interface Konto {
    kontoNr: number;
    name: string;
    useKst: DimensionUse;
    usePrj: DimensionUse;
    useObjekt3: DimensionUse;
    hidden?: boolean;
}

interface Objekt {
    objektKod: string;
    name: string;
    hidden?: boolean;
}

export interface Charts {
    konton: Konto[];
    kontoDict: Record<number, Konto>;
    kst: Objekt[];
    prj: Objekt[];
    objekt3: Objekt[];

    getKonto: (kontoNr: number) => Konto;
}

function parseDimensionUse(raw: string): DimensionUse {
    return parseInt(raw) == 1 ? DimensionUse.Ja : DimensionUse.Nej;
}

function parseRawKontoplan(data: any): Konto[] {
    const ktoPlanRaw = data as string[][];
    return ktoPlanRaw.map(row => {
        return {
            kontoNr: parseInt(row[0]),
            name: row[1],
            useKst: parseDimensionUse(row[2]),
            usePrj: parseDimensionUse(row[3]),
            useObjekt3: parseDimensionUse(row[4]),
            hidden: parseInt(row[5]) == 1,
        };
    });
}

function parseRawObjektplan(data: any): Objekt[] {
    const ktoPlanRaw = data as string[][];
    return ktoPlanRaw.map(row => {
        return { objektKod: row[0], name: row[1], hidden: parseInt(row[2]) == 1 };
    });
}

function parseCharts(data: any): Charts {
    const retval = {
        konton: parseRawKontoplan(data[0]),
        kst: parseRawObjektplan(data[1]),
        prj: parseRawObjektplan(data[2]),
        objekt3: parseRawObjektplan(data[3]),
        
    } as Charts;

    let dictionary = Object.assign({}, ...retval.konton.map((x) => ({[x.kontoNr]: x}))) as Record<number, Konto>;
    retval.kontoDict = dictionary;

    retval.getKonto = ((kontoNr: number) => retval.kontoDict[kontoNr]);
    
    return retval;
}

export function useJsRpcPlaner() {
    const [data, setData] = useState<Charts | undefined>(null);
  
    useEffect(() => {
        if (window.JSRpcPlaner) {
            const tmp = parseCharts(window.JSRpcPlaner);
            setData(tmp);
        }
    }, [window.JSRpcPlaner]);
  
    return data;
  }
